$('[data-toggle="radio"]:radio').on('change', function () {
    const $this = $(this);
    const target = $($this.attr('data-target'));
    const parent = $($this.attr('data-parent'));

    if (parent) {
        parent.find('.collapse').removeClass('in');
    }

    if (target) {
        if ($this.is(':checked')) {
            target.addClass('in');
        } else {
            target.removeClass('in');
        }
    }
});
